module.exports = __webpack_public_path__ + "static/services-photo-a7e8692f76e642b4860f46980972679e.jpg";